import React, { useState, useEffect } from 'react';
import mockUser from '../mock/mockUser';

const FactFinder = () => {
  const [fact, setFact] = useState(mockUser.factFinder);
  const [onboardingAnswers, setOnboardingAnswers] = useState(null);

  // Load onboarding answers from localStorage
  useEffect(() => {
    const savedAnswers = localStorage.getItem('zecher_onboarding_answers');
    if (savedAnswers) {
      try {
        setOnboardingAnswers(JSON.parse(savedAnswers));
      } catch (error) {
        console.error('Error parsing onboarding answers:', error);
      }
    }
  }, []);

  // Helper for updating nested fields
  const handleChange = (section, field, value) => {
    setFact((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };

  // Helper for updating onboarding answers
  const handleOnboardingChange = (field, value) => {
    const updatedAnswers = { ...onboardingAnswers, [field]: value };
    setOnboardingAnswers(updatedAnswers);
    localStorage.setItem('zecher_onboarding_answers', JSON.stringify(updatedAnswers));
  };

  // For array fields (e.g., pets, goals), you could add more advanced handlers later

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Fact Finder</h1>
      
      {/* Onboarding Questionnaire Section */}
      {onboardingAnswers && (
        <div className="bg-blue-50 rounded-2xl shadow-sm p-6 mb-6">
          <h2 className="text-lg font-medium text-blue-900 mb-4">🎯 Initial Questionnaire Responses</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-blue-700">What's important to you about money?</label>
              <textarea 
                className="mt-1 w-full border border-blue-200 rounded px-3 py-2 bg-white" 
                rows="3"
                value={onboardingAnswers.q1 || ''} 
                onChange={e => handleOnboardingChange('q1', e.target.value)}
                placeholder="No response recorded"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-blue-700">Current relationship with money (one word + why)</label>
              <textarea 
                className="mt-1 w-full border border-blue-200 rounded px-3 py-2 bg-white" 
                rows="3"
                value={onboardingAnswers.q2 || ''} 
                onChange={e => handleOnboardingChange('q2', e.target.value)}
                placeholder="No response recorded"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-blue-700">Money memories from growing up</label>
              <textarea 
                className="mt-1 w-full border border-blue-200 rounded px-3 py-2 bg-white" 
                rows="3"
                value={onboardingAnswers.q3 || ''} 
                onChange={e => handleOnboardingChange('q3', e.target.value)}
                placeholder="No response recorded"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-blue-700">Money habits (proud of vs. want to improve)</label>
              <textarea 
                className="mt-1 w-full border border-blue-200 rounded px-3 py-2 bg-white" 
                rows="3"
                value={onboardingAnswers.q4 || ''} 
                onChange={e => handleOnboardingChange('q4', e.target.value)}
                placeholder="No response recorded"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-blue-700">What does "financial peace of mind" look like?</label>
              <textarea 
                className="mt-1 w-full border border-blue-200 rounded px-3 py-2 bg-white" 
                rows="3"
                value={onboardingAnswers.q5 || ''} 
                onChange={e => handleOnboardingChange('q5', e.target.value)}
                placeholder="No response recorded"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-blue-700">Goals from this process</label>
              <textarea 
                className="mt-1 w-full border border-blue-200 rounded px-3 py-2 bg-white" 
                rows="3"
                value={onboardingAnswers.q6 || ''} 
                onChange={e => handleOnboardingChange('q6', e.target.value)}
                placeholder="No response recorded"
              />
            </div>

            {/* Timeline Goals */}
            <div>
              <label className="block text-sm font-medium text-blue-700 mb-2">Timeline Goals</label>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                <div>
                  <label className="block text-xs text-blue-600">1 Year</label>
                  <input 
                    type="text" 
                    className="w-full border border-blue-200 rounded px-2 py-1 text-sm bg-white" 
                    value={onboardingAnswers.q7_1 || ''} 
                    onChange={e => handleOnboardingChange('q7_1', e.target.value)}
                    placeholder="1 year goals"
                  />
                </div>
                <div>
                  <label className="block text-xs text-blue-600">3 Years</label>
                  <input 
                    type="text" 
                    className="w-full border border-blue-200 rounded px-2 py-1 text-sm bg-white" 
                    value={onboardingAnswers.q7_3 || ''} 
                    onChange={e => handleOnboardingChange('q7_3', e.target.value)}
                    placeholder="3 year goals"
                  />
                </div>
                <div>
                  <label className="block text-xs text-blue-600">5 Years</label>
                  <input 
                    type="text" 
                    className="w-full border border-blue-200 rounded px-2 py-1 text-sm bg-white" 
                    value={onboardingAnswers.q7_5 || ''} 
                    onChange={e => handleOnboardingChange('q7_5', e.target.value)}
                    placeholder="5 year goals"
                  />
                </div>
                <div>
                  <label className="block text-xs text-blue-600">10 Years</label>
                  <input 
                    type="text" 
                    className="w-full border border-blue-200 rounded px-2 py-1 text-sm bg-white" 
                    value={onboardingAnswers.q7_10 || ''} 
                    onChange={e => handleOnboardingChange('q7_10', e.target.value)}
                    placeholder="10 year goals"
                  />
                </div>
                <div>
                  <label className="block text-xs text-blue-600">20 Years</label>
                  <input 
                    type="text" 
                    className="w-full border border-blue-200 rounded px-2 py-1 text-sm bg-white" 
                    value={onboardingAnswers.q7_20 || ''} 
                    onChange={e => handleOnboardingChange('q7_20', e.target.value)}
                    placeholder="20 year goals"
                  />
                </div>
              </div>
            </div>

            {/* Show personality traits if available */}
            {onboardingAnswers.personalityTraits && onboardingAnswers.personalityTraits.length > 0 && (
              <div>
                <label className="block text-sm font-medium text-blue-700">Personality Traits</label>
                <div className="mt-1 flex flex-wrap gap-2">
                  {onboardingAnswers.personalityTraits.map((trait, index) => (
                    <span key={index} className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
                      {trait}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Personal Section */}
      <div className="bg-white rounded-2xl shadow-sm p-6 mb-6">
        <h2 className="text-lg font-medium text-gray-900 mb-4">Personal</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Full Name</label>
            <input type="text" className="mt-1 w-full border rounded px-3 py-2" value={fact.personal.fullName} onChange={e => handleChange('personal', 'fullName', e.target.value)} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">DOB</label>
            <input type="date" className="mt-1 w-full border rounded px-3 py-2" value={fact.personal.dob} onChange={e => handleChange('personal', 'dob', e.target.value)} />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700">Address</label>
            <input type="text" className="mt-1 w-full border rounded px-3 py-2" value={fact.personal.address} onChange={e => handleChange('personal', 'address', e.target.value)} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Marital Status</label>
            <input type="text" className="mt-1 w-full border rounded px-3 py-2" value={fact.personal.maritalStatus} onChange={e => handleChange('personal', 'maritalStatus', e.target.value)} />
          </div>
        </div>
      </div>
      
      {/* Employment Section */}
      <div className="bg-white rounded-2xl shadow-sm p-6 mb-6">
        <h2 className="text-lg font-medium text-gray-900 mb-4">Employment</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Employer</label>
            <input type="text" className="mt-1 w-full border rounded px-3 py-2" value={fact.employment.employer} onChange={e => handleChange('employment', 'employer', e.target.value)} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Title</label>
            <input type="text" className="mt-1 w-full border rounded px-3 py-2" value={fact.employment.title} onChange={e => handleChange('employment', 'title', e.target.value)} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Base Salary</label>
            <input type="number" className="mt-1 w-full border rounded px-3 py-2" value={fact.employment.baseSalary} onChange={e => handleChange('employment', 'baseSalary', e.target.value)} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Bonus</label>
            <input type="number" className="mt-1 w-full border rounded px-3 py-2" value={fact.employment.bonus} onChange={e => handleChange('employment', 'bonus', e.target.value)} />
          </div>
        </div>
      </div>
      
      {/* Add more sections: Banking, Liabilities, Insurance, Estate, Cost of Living, Goals, etc. */}
      <button className="bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold mt-4">Save</button>
    </div>
  );
};

export default FactFinder; 